var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import AppContainer from "@irati/ui/src/AppContainer";
import intercom from "@irati/utils/intercom";
import { DesktopOnlySupported } from "../../components";
import { PartialGrid } from "../../components/styled";
var TenantOnboardingContainer = /** @class */ (function (_super) {
    __extends(TenantOnboardingContainer, _super);
    function TenantOnboardingContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentDidMount = function () { return intercom.hide(); };
        _this.componentWillUnmount = function () { return intercom.show(); };
        return _this;
    }
    TenantOnboardingContainer.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, children = _a.children;
        return (React.createElement(AppContainer, { hasFooter: false, isFlush: true },
            React.createElement(PartialGrid, null,
                isMobile && React.createElement(DesktopOnlySupported, null),
                !isMobile && children)));
    };
    return TenantOnboardingContainer;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: mq.lessThan.medium
    });
};
export default connect(mapStateToProps)(TenantOnboardingContainer);
